import styled, { keyframes } from "styled-components";

export const PwBackground = styled.div`
  box-sizing: border-box;
  background: url(/Tele-Philips.png) no-repeat center;
  background-size: cover;
  height: 100vh;
  display: flex;
  /* gap: 4em; */
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: ${(props) => (props.shake ? shake1 : "none")} 0.5s linear;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  /* overflow-y: hidden; */
`;

// export const LogoImg = styled.img`
// height: 300px;
// width: auto;
// `


const shake1 = keyframes`
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  50% {
    transform: translateX(5px);
  }
  75% {
    transform: translateX(-5px);
  }
  100% {
    transform: translateX(0);
  }
`;

export const PwForm = styled.form`
  animation: ${(props) => (props.shake ? shake1 : "none")} 0.5s linear;

`;




export const Pwinput = styled.input`
  background-color: rgba(34, 34, 34, 0.8);
  color: white;
  border: none;
  height: 50px;
  max-width: 500px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  opacity: 0.8;
  padding: 0 16px;
  box-sizing: border-box;
  vertical-align: middle;

  font-size: 16px;

  &:focus {
    outline: none;
  }

`;

export const PwSubmit = styled.button`
  background-color: rgba(46, 168, 181, 0.672);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  height: 50px;
  color: white;
  border: none;
  padding: 0 16px;
  opacity: 0.8;
  box-sizing: border-box;
  vertical-align: middle;
  &:focus {
    /* outline: none; */
    box-shadow: 0px 0px 0px 2px rgba(46, 168, 181, 0.672);
  }
`;
